// @ts-nocheck
import { Plugin } from '/data/app/jenkins/data/workspace/FESingleCommon/node_modules/.pnpm/@umijs+runtime@3.5.40_react@17.0.2/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
